import React, { useEffect, useLayoutEffect, useRef } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import lottie from 'lottie-web';
import kct_loading from '../assets/Konnect_Loader.gif';
// import loading from '../assets/lottie/lf20_zh3oihg6.json';

export default function Loading() {
	useEffect(() => {
		lottie.loadAnimation({
			container: document.getElementById('loading'),
			renderer: 'svg',
			loop: true,
			autoplay: true,
			path: '../assets/lottie/konnect_loader.json',
		});

		return () => {
			lottie.destroy();
		};
	}, []);

	return (
		<>
			<GlobalStyle />
			<Container>
				<LoadingBox id='loading' />
			</Container>
		</>
	);
}

const GlobalStyle = createGlobalStyle`
    body {
        overflow: hidden;
    }
`;

const Container = styled.div`
	position: fixed;
	z-index: 9999;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	background: #0000007d;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const LoadingBox = styled.div`
	width: ${window.innerWidth < 1200 ? '240px' : '400px'};
`;
// const LoadingBox = styled.img`
//     width: 300px;
// `
